import React, { useEffect, useContext, useState } from "react";
import { AuthContext } from '../../contexts/auth';
import { Popover } from '@headlessui/react';
import UploadFormRimborso from "../../components/areariservata/upload_form_rimborso";
import UploadFormRimborsoKm from "../../components/areariservata/upload_form_rimborso_km";
import { createRichiestaRimborsoSpese, storicoRichiesteRimborsoSpese, deleteRichiestaRimborsoSpese } from "../../services/api_dipendenti";
import Swal from "sweetalert2";
import { PencilSquareIcon, TrashIcon, ChevronDownIcon, ChevronUpIcon, ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import Fetching from "../../components/fetching";
import XCircleIcon from '@heroicons/react/24/outline/esm/XCircleIcon';
import CheckCircleIcon from '@heroicons/react/24/outline/esm/CheckCircleIcon';
import moment from "moment";
import Empty from '../../components/empty';
import CalendarMonthSelect from '../../components/calendar_month_select';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function RimborsoSpese() {
  const { token } = useContext(AuthContext);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isLoading , setIsLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showFormRimborsoKm, setShowFormRimborsoKm] = useState(false);
  const [editRecordId, setEditRecordId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isError, setIsError] = useState(false);
  const [hideButtonDetails, setHideButtonDetails] = useState(false);
  const [visibleRecordId, setVisibleRecordId] = useState(null);
  const [currentRecord, setCurrentRecord] = useState(null); 
  const [isEditing, setIsEditing] = useState(false);
  const [calendarVisible, setCalendarVisible] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [showButtonKm, setShowButtonKm] = useState(true);
  const [showButtonSpese, setShowButtonSpese] = useState(true);

  useEffect(() => {
    const month = selectedMonth.getMonth() + 1;
    const year = selectedMonth.getFullYear();
    fetchRecords(currentPage, '', month, year);
  }, [currentPage, selectedMonth]);
  
  const fetchRecords = async (page, status, month, year) => {
    setIsLoading(true);
    try {
      const response = await storicoRichiesteRimborsoSpese(token, page, status, 10, month, year);
      setRecords(response.results);
      setTotalPages(Math.ceil(response.count / 10));
    } catch (error) {
      console.error(error);
      setError(error);
    } finally {
      setIsLoading(false);
    }
  }
  

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prevPage => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prevPage => prevPage - 1);
    }
  };

  const toggleForm = () => {
    if (editRecordId) {
      Swal.fire({
        icon: 'warning',
        title: 'Operazione in corso',
        text: 'Completa l\'operazione in corso prima di creare un nuovo rimborso.',
        confirmButtonText: 'OK'
      });
    } else {
      setShowForm(!showForm);
      setShowButtonKm(!showButtonKm);
    }
  };

  const toggleFormRimborsoKm = () => {
    if (editRecordId) {
      Swal.fire({
        icon: 'warning',
        title: 'Operazione in corso',
        text: 'Completa l\'operazione in corso prima di creare un nuovo rimborso.',
        confirmButtonText: 'OK'
      });
    } else {
      setShowFormRimborsoKm(!showFormRimborsoKm);
      setShowButtonSpese(!showButtonSpese);
    }
  };

  const toggleDetails = (recordId) => {
    setVisibleRecordId((prevId) => (prevId === recordId ? null : recordId));
  };

  const submitForm = async (formData) => {
    const response = await createRichiestaRimborsoSpese(token, formData)
    return response
  }

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Sei sicuro?',
      text: "Stai eliminando la richiesta di un rimborso e l'operazione non è reversibile. Confermi l'eliminazione?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sì, confermo',
      cancelButtonText: 'No, annulla',
      reverseButtons: true
    });
  
    if (result.isConfirmed) {
      try {
        await deleteRichiestaRimborsoSpese(token, id);
        await Swal.fire({
          title: 'Eliminato!',
          text: 'La richiesta è stata eliminata.',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
  
        setRecords((prevRecords) =>
          prevRecords.filter((record) => record.id !== id)
        );
        fetchRecords(currentPage);
      } catch (error) {
        Swal.fire('Errore!', 'Si è verificato un errore durante l\'eliminazione.', 'error');
      }
    }
  };

  const handleEdit = (record) => {
    if (showForm || showFormRimborsoKm) {
      Swal.fire({
        icon: 'warning',
        title: 'Operazione in corso',
        text: 'Chiudi il form di creazione prima di modificare una richiesta.',
        confirmButtonText: 'OK'
      });
    } else {
      setCurrentRecord(record);
      setIsEditing(true);
      setEditRecordId(record.id);
      setVisibleRecordId(null);
      setHideButtonDetails(true);
    }
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setCurrentRecord(null);
    setEditRecordId(null);
    setHideButtonDetails(false);
  };

  const handleAfterSubmitEditRecord = async (updatedRecord) => {
    setRecords((prevRecords) =>
      prevRecords.map((record) =>
        record.id === updatedRecord.id ? updatedRecord : record
      )
    );

    await fetchRecords(
      currentPage, 
      '',
      selectedMonth.getMonth() + 1, 
      selectedMonth.getFullYear()
    );

    setEditRecordId(null);
    setHideButtonDetails(false);
    setShowForm(false);
    
  };

  const handlePreviousMonth = () => {
    setSelectedMonth(new Date(selectedMonth.getFullYear(), selectedMonth.getMonth() - 1, 1));
  };
  
  const handleNextMonth = () => {
    setSelectedMonth(new Date(selectedMonth.getFullYear(), selectedMonth.getMonth() + 1, 1));
  };
  
  const handleSelectClick = () => {
    setCalendarVisible(!calendarVisible);
  };

  return <div>
    <Popover as="header" className={`bg-indigo-200`}>
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="relative flex flex-wrap items-center justify-center lg:justify-between">
          <div className="w-full -5 lg:border-t lg:border-white lg:border-opacity-20">
            <div className="flex justify-center my-2 py-2">
              <h2 className="text-center text-2xl font-semibold text-indigo-800">Rimborso Spese</h2>
            </div>
          </div>
        </div>
      </div>
    </Popover>
    
    <section>
      <div className="container-fluid w-full px-4 pt-2">

        <div className="grid sm:grid-cols-6 gap-4 mt-2 items-center px-10">
          <div className='col-span-4 flex items-center mt-4'>
          <h3 className="text-base font-semibold leading-6 text-gray-900">Inserisci una nuova richiesta di rimborso</h3>
            {showButtonSpese && (
              <button
                onClick={toggleForm}
                className={`ml-4 text-sm p-2 rounded-md font-semibold w-56 whitespace-nowrap ${showForm ? 'bg-gray-200 text-gray-800 hover:bg-gray-400 hover:text-white' : 'bg-indigo-500 text-white hover:bg-indigo-400'}`}
              >
                {showForm ? 'Annulla' : 'Rimborso Spese'}
              </button>
            )}
            {showButtonKm && (
              <button
                onClick={toggleFormRimborsoKm}
                className={`ml-4 text-sm p-2 rounded-md font-semibold w-56 whitespace-nowrap ${showFormRimborsoKm ? 'bg-gray-200 text-gray-800 hover:bg-gray-400 hover:text-white' : 'bg-indigo-500 text-white hover:bg-indigo-400'}`}
              >
                {showFormRimborsoKm ? 'Annulla' : 'Rimborso Chilometrico'}
              </button>
            )}
          </div>
        </div>
        {showForm && (
          <>
            <h1 className='text-center text-xl font-semibold text-indigo-800 bg-indigo-100 rounded-md mt-8'>Nuovo Rimborso Spese</h1>
            <UploadFormRimborso 
              submitForm={submitForm} 
              showForm={showForm}
              afterSubmit={() => {
                setShowForm(false);
                setShowFormRimborsoKm(false);
                setShowButtonSpese(true);
                setShowButtonKm(true);
                fetchRecords();
              }}
            />
          </> 
        )}
        {showFormRimborsoKm && (
          <>
            <h1 className='text-center text-xl font-semibold text-indigo-800 bg-indigo-100 rounded-md mt-8'>Nuovo Rimborso Chilometrico</h1>
            <UploadFormRimborsoKm 
              submitForm={submitForm} 
              showForm={showForm}
              afterSubmit={() => {
                setShowForm(false);
                setShowFormRimborsoKm(false);
                setShowButtonSpese(true);
                setShowButtonKm(true);
                fetchRecords();
              }}
            />
          </> 
        )}
      </div>
    </section>

    <section>
      <div className="container-fluid w-full px-4 pt-8">
        <div className="grid grid-cols-6 gap-4 mt-2 items-center px-10">
          <div className='col-span-4'>
            <h3 className="text-base font-semibold leading-6 text-gray-900">Riepilogo</h3>
          </div>
        </div>
      </div>
    </section>
      
     
    <div className="px-4 sm:px-6 lg:px-8 mt-5">
      <div className="max-h-[90vh] overflow-y-auto overflow-x-auto ring-1 ring-gray-300 sm:mx-0 sm:rounded-lg">
        
        <div className='grid grid-cols-1 w-full py-4 sticky top-0 bg-white z-20'>
          <div
            style={{ flex: '1 1 auto', width: 'auto' }}
            className="pb-5 pt-2 px-4 border-l border-r border-gray-200 text-center w-24 text-xs font-semibold text-gray-600 uppercase align-middle"
          >
            <div className='grid  md:grid-cols-5 sm:justify-start md:justify-around grid-cols-3'>
                <div className='col-span-1 p-2 flex align-center justify-end sm:justify-center md:justify-end me-3'>
                    <button
                        className='text-gray-700 font-semibold px-1 hover:bg-gray-100'
                        onClick={handlePreviousMonth} 
                    >
                        <ChevronLeftIcon className="w-5 h-5 cursor-pointer" />
                    </button>
                </div>
                <div className='col-span-1 p-2 flex align-center md:justify-end sm:justify-center me-3'>Seleziona Mese</div>
                <div className='col-span-1 p-2 align-center justify-start sm:justify-center md:justify-start md:hidden block'>
                    <button
                        className='text-gray-700 font-semibold px-1 hover:bg-gray-100'
                        onClick={handleNextMonth}
                    >
                        <ChevronRightIcon className='w-5 h-5 cursor-pointer' />
                    </button>
                </div>
                <div
                    onClick={handleSelectClick}
                    style={{ cursor: 'pointer' }}
                    className='col-span-3 md:col-span-2 border border-gray-300 rounded-md shadow-md p-2 pl-4 flex items-center md:w-4/5 w-full justify-between'
                >
                    <div>
                        {selectedMonth.toLocaleDateString('it-IT', { month: 'long' })}, {selectedMonth.getFullYear()}
                    </div>
                    {!calendarVisible ? <ChevronDownIcon className='h-4 w-4 bg-indigo-100 rounded-md' /> : <ChevronUpIcon className='h-4 w-4 bg-indigo-100 rounded-md' />}
                </div>
                <div className='col-span-1 p-2 align-start justify-start hidden md:block'>
                    <button
                        className='text-gray-700 font-semibold px-1 hover:bg-gray-100 flex items-start'
                        onClick={handleNextMonth}
                    >
                        <ChevronRightIcon className='w-5 h-5 cursor-pointer' />
                    </button>
                </div>
            </div>
            {calendarVisible && 
              <CalendarMonthSelect
                selectedMonth={selectedMonth} 
                onMonthSelect={setSelectedMonth} 
                onCloseCalendar={handleSelectClick}
              />
            }
          </div>      
        </div>

        <table className="min-w-full divide-y divide-gray-300">
          <thead className='sticky top-0 bg-white z-10 border-b border-gray-200'>
            <tr>
              <th scope="col" className="py-3.5 pl-4 text-left text-sm font-semibold text-gray-900">
                Oggetto
              </th>
              <th scope="col" className="py-3.5 pl-4 text-left text-sm font-semibold text-gray-900">
                Importo
              </th>
              <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">
                Status
              </th>
              <th scope="col" className="text-right text-sm font-semibold text-gray-900">
                
              </th>
            </tr>
          </thead>
          <tbody>
            {(isLoading) && (
              <tr>
                <td colSpan={6} className="text-center">
                  <Fetching />
                </td>
              </tr>
            )}
            {!isError && records.length > 0 ? (
              records.sort((a, b) => b.id - a.id).map((record) => (
                <React.Fragment key={record.id}>
                  <tr>
                    <td className="relative py-4 pl-4 pr-3 text-sm sm:pl-6 border-b">
                      <div className="font-medium text-gray-900">
                        {record.title.length > 15 ? record.title.substring(0, 15) + "..." : record.title}
                      </div>
                    </td>
                    <td className="relative py-4 pl-4 pr-3 text-sm sm:pl-6 border-b">
                      {record.title == 'Rimborso Chilometrico' ?
                      (
                        <div className="font-medium text-gray-900">KM {record.amount}</div>
                      ) : (
                        <div className="font-medium text-gray-900">€ {record.amount}</div>
                      )}
                    </td>
                    <td className="relative py-4 pl-4 pr-3 text-sm sm:pl-6 border-b text-center">
                      {record.status === 'approved' ? (
                        <CheckCircleIcon className="w-5 h-5 text-teal-500 mx-auto" />
                      ) : record.status === 'rejected' ? (
                        <XCircleIcon className="w-5 h-5 text-red-500 mx-auto" />
                      ) : (
                        <div>
                          In attesa di approvazione
                        </div>
                      )}
                    </td>
                    <td className="relative text-sm border-b text-end pe-4">
                    {!hideButtonDetails && (
                      <button
                        onClick={() => toggleDetails(record.id)}
                        className="text-sm font-semibold bg-gray-200 hover:bg-gray-300 w-28 p-1 text-gray-600 rounded-md"
                      >
                        {visibleRecordId === record.id ? 'Chiudi' : 'Più dettagli'}
                      </button>
                    )}
                    </td>
                  </tr>

                  {visibleRecordId === record.id && (
                    <>
                      {record.status === null && (
                        <tr className="bg-indigo-50">
                          <td colSpan="10" className="pt-4 px-4 text-gray-700 text-sm text-right pb-0">
                            <button className='px-2 text-sm font-semibold bg-indigo-500 hover:bg-indigo-400 p-1 text-white rounded-md me-3' onClick={() => handleEdit(record)}> 
                              <PencilSquareIcon className='h-5 w-5 inline-block' /> Modifica Richiesta
                            </button>
                            <button className='px-2 text-sm font-semibold bg-indigo-500 hover:bg-indigo-400 p-1 text-white rounded-md'
                              onClick={() => handleDelete(record.id)}
                            >
                              <TrashIcon className='h-5 w-5 inline-block' /> Elimina
                            </button>
                          </td>
                        </tr>
                      )}

                      {/* Oggetto */}
                      <tr key={`${record.id}-title`} className="bg-indigo-50">
                        <td colSpan="10" className="py-2 px-6 text-gray-700 text-sm text-left">
                          <span className="font-medium text-gray-900">Oggetto </span>
                          {record.title}
                        </td>
                      </tr>

                      {/* DATA */}
                      <tr key={`${record.id}-date`} className="bg-indigo-50">
                        <td colSpan="10" className="py-2 px-6 text-gray-700 text-sm text-left">
                          <span className="font-medium text-gray-900">Data </span>
                          {record.date ? (
                          <time dateTime={record.date}>
                            {moment(record.date).format('DD/MM/YYYY')}
                          </time>
                        ) : (
                          ''
                        )}
                        </td>
                      </tr>

                      {/* Importo */}
                      <tr key={`${record.id}-amount`} className="bg-indigo-50">
                        <td colSpan="10" className="py-2 px-6 text-gray-700 text-sm text-left">
                          {record.title == 'Rimborso Chilometrico' ? (
                            <>
                              <span className="font-medium text-gray-900">KM </span>
                              {record.amount}
                            </>
                          ) : (
                            <>
                              <span className="font-medium text-gray-900">Importo </span>
                              € {record.amount}
                            </>
                          )}
                        </td>
                      </tr>

                      {/* Description */}
                      <tr key={`${record.id}-description`} className="bg-indigo-50">
                        <td colSpan="10" className="py-2 px-6 text-gray-700 text-sm text-left">
                          <span className="font-medium text-gray-900">Descrizione </span>
                          <div
                            className="description-content"
                            dangerouslySetInnerHTML={{ __html: record.description || '' }}
                          />
                        </td>
                      </tr>

                      {/* Files */}
                      <tr key={`${record.id}-file`} className="bg-indigo-50">
                        <td colSpan="10" className="py-2 px-6 text-gray-700 text-sm text-left">
                          <span className="font-medium text-gray-900">Allegati </span>
                          {record.file && <a href={record.file} className="text-sm font-semibold bg-indigo-500 hover:bg-indigo-400 p-1 ml-3 text-white rounded-md" target="_blank">Visualizza</a>}
                        </td>
                      </tr>

                      {/* Reviewed On */}
                      {record.status !== null && (
                        <tr key={`${record.id}-reviewed_on`} className="bg-indigo-50">
                          <td colSpan="10" className="py-2 px-6 text-gray-700 text-sm text-left">
                            <span className="font-medium text-gray-900">Richiesta elaborata il </span>
                            <time dateTime={record.reviewed_on}>
                              {record.reviewed_on
                                ? moment(record.reviewed_on).format('DD/MM/YYYY, HH:mm')
                                : ''}
                            </time>
                          </td>
                        </tr>
                      )}
                    </>
                  )}               

                  {editRecordId === record.id && (
                    <tr>
                      <td colSpan="10" className="py-4">
                      {record.title === 'Rimborso Chilometrico' ? (
                        <UploadFormRimborsoKm 
                          submitForm={submitForm} 
                          afterSubmitEditRecord={handleAfterSubmitEditRecord}
                          recordToEdit={record} 
                          onCancelEdit={handleCancelEdit} 
                        />
                      ) : (
                        <UploadFormRimborso 
                          submitForm={submitForm} 
                          afterSubmitEditRecord={handleAfterSubmitEditRecord}
                          recordToEdit={record} 
                          onCancelEdit={handleCancelEdit} 
                        />
                      )}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))
            ) :(
              !isError && records.length === 0 && !isLoading && (
                <tr>
                  <td colSpan="10" className='container-fluid w-full px-4 pt-4'>
                    <Empty />
                  </td>
                </tr>
              )
            )}
            
            {/* Paginazione */}
            <tr className='bg-gray-50 sticky bottom-0 z-10'>
              <td colSpan="10" className="py-4">
                <div className="flex items-center justify-between">
                  <button
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                    className={`border rounded-md shadow-sm text-sm font-semibold text-center px-3 py-1 ml-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                      currentPage === 1 ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
                    }`}
                  >
                    Pagina precedente
                  </button>

                  <div className="text-sm font-semibold text-gray-800 px-2">
                    Pagina {currentPage} di {totalPages}
                  </div>

                  <button
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                    className={`border rounded-md shadow-sm text-sm font-semibold text-center px-3 py-1 mr-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                      currentPage === totalPages ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
                    }`}
                  >
                    Pagina successiva
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
}